import React, { useState } from "react";
import CustomModal from "./CustomModal";
import { FinalizeDayCloseApi } from "../../ApiRequests";
import { fmtReportRs } from "../../utils/reportSummary";
import { SuccessToast, ErrorToast } from "../../utils/ShowToast";

const FinalizeClosingModal = ({
  open,
  onClose,
  onSuccess,
  branchId,
  closeDate,
  openingBalance,
  closingBalance,
  totalIn,
  totalOut,
}) => {
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleFinalize = async () => {
    if (!branchId) {
      ErrorToast("Branch missing — cannot finalize closing");
      return;
    }
    if (!closeDate) {
      ErrorToast("Select a single day to finalize closing");
      return;
    }
    setSubmitting(true);
    try {
      const res = await FinalizeDayCloseApi({
        branchId,
        date: closeDate,
        note,
      });
      const payload = res?.data?.data?.payload;
      const nextOpening = payload?.next_day_opening;
      const nextDay = payload?.next_day;
      SuccessToast(
        res?.data?.data?.msg ||
          `Closing saved. Next day (${nextDay}) opening = ${fmtReportRs(nextOpening)}`
      );
      onSuccess?.(payload);
      onClose?.();
    } catch (err) {
      ErrorToast(
        err?.response?.data?.error?.msg ||
          err?.message ||
          "Failed to finalize closing"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <CustomModal
      open={open}
      setOpen={(next) => {
        if (!next) onClose?.();
      }}
    >
      <div className="w-[min(440px,92vw)] p-5 font-quicksand">
        <h2 className="text-lg font-extrabold text-ink">Finalize closing</h2>
        <p className="text-sm text-muted mt-1">
          Save CASH closing for{" "}
          <span className="font-semibold text-ink">{closeDate}</span>. This
          becomes the opening balance for the next day.
        </p>

        <div className="mt-4 rounded-xl border border-line bg-subtle/60 divide-y divide-line text-sm">
          <div className="flex justify-between px-3.5 py-2.5">
            <span className="text-inkSecondary">Opening</span>
            <span className="font-bold tabular-nums text-ink">
              {fmtReportRs(openingBalance)}
            </span>
          </div>
          <div className="flex justify-between px-3.5 py-2.5">
            <span className="text-inkSecondary">Total DR (In)</span>
            <span className="font-bold tabular-nums text-success">
              {fmtReportRs(totalIn)}
            </span>
          </div>
          <div className="flex justify-between px-3.5 py-2.5">
            <span className="text-inkSecondary">Total CR (Out)</span>
            <span className="font-bold tabular-nums text-danger">
              {fmtReportRs(totalOut)}
            </span>
          </div>
          <div className="flex justify-between px-3.5 py-2.5 bg-brandSoft/50">
            <span className="font-bold text-ink">Closing → next opening</span>
            <span className="font-extrabold tabular-nums text-main text-base">
              {fmtReportRs(closingBalance)}
            </span>
          </div>
        </div>

        <label className="block mt-4">
          <span className="text-xs font-semibold text-inkSecondary">
            Note (optional)
          </span>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={2}
            className="mt-1.5 w-full rounded-lg border border-line bg-field px-3 py-2 text-sm text-ink outline-none focus:border-main focus:ring-2 focus:ring-main/15"
            placeholder="e.g. Verified with physical cash count"
          />
        </label>

        <div className="mt-5 flex gap-2 justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="h-10 px-4 rounded-lg border border-line text-sm font-bold text-inkSecondary hover:border-main/40"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleFinalize}
            disabled={submitting}
            className="h-10 px-4 rounded-lg border-2 border-main bg-main text-white text-sm font-bold hover:bg-mainHover disabled:opacity-60"
          >
            {submitting ? "Saving…" : "Confirm finalize"}
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default FinalizeClosingModal;
